import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { useState, useEffect } from 'react';

function useRefStyle(style, refElement) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    computedStyle = _useState2[0],
    setComputedStyle = _useState2[1];
  useEffect(function () {
    if (refElement) {
      var refStyle = window.getComputedStyle(refElement);
      setComputedStyle(refStyle[style]);
    }
  }, [refElement, style]);
  return computedStyle;
}

export { useRefStyle as default };
//# sourceMappingURL=use-ref-style.esm.js.map
